<div
  [ngClass]="{
    'global-input-mat': global(),
  }"
>
  <ng-container *transloco="let t; prefix: 'uiKit'">
    @if (!formControl) {
      <mat-form-field>
        <mat-date-range-input
          class="cursor-pointer"
          [rangePicker]="pickerMat"
          (click)="pickerMat.open()"
        >
          <input
            #dateRangeStart
            class="cursor-pointer"
            readonly
            matStartDate
            [(ngModel)]="rangeDates().dateStart"
            [placeholder]="t('placeholders.startDate')"
          />
          <input
            #dateRangeEnd
            class="cursor-pointer"
            readonly
            matEndDate
            [(ngModel)]="rangeDates().dateEnd"
            [placeholder]="t('placeholders.endDate')"
            (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)"
          />
          <input matInput class="d-none" />
        </mat-date-range-input>
        <button
          class="btn calendar-btn-m"
          type="button"
          [ngClass]="{
            'bi bi-calendar3 btn-primary': !areBothDatesSelected(),
            'bi bi-trash btn-danger': areBothDatesSelected(),
          }"
          (click)="onButtonClick()"
          [attr.aria-label]="
            areBothDatesSelected()
              ? 'Clear date range'
              : 'Open date range picker'
          "
        ></button>
        <mat-date-range-picker
          #pickerMat
          [calendarHeaderComponent]="formRangeDatepickerHeader"
        ></mat-date-range-picker>
      </mat-form-field>
    }
  </ng-container>
</div>
@if (control() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
